import baxterAvatar from '../images/baxter_avatar_white.ico';

export default function Footer() {
    return (
        <footer className="pt-4 pb-4 text-center text-sm text-gray-500 bg-zinc-900">
            <p>
                Hecho con <span className="text-red-500">♥</span> por{" "}
                <a
                    href="https://baxterdev.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                >
                    baxterdev.com
                </a>
            </p>
            <div className="mt-4 flex justify-center">
                <img
                    src={baxterAvatar}
                    alt="Baxter Avatar"
                    className="h-10 w-10 object-contain"
                />
            </div>
        </footer>
    );
}
